let knownErrors = {
	2: async (error) => {
		$notify('error', 'Authentication Error', error.err_msg);
	},
	USER_EXIST: async (error) => {
		$notify(
			'error',
			'User Already Exists',
			'The email already exists. Try a different one',
		);
	},
	TNC_ERROR: async (error) => {
		$notify(
			'warning',
			'Terms And Conditions',
			'You have to accept the terms and conditions',
		);
	},
	unknown: async (error) => {
		$notify('error', 'Unknown Error', 'Unknown Error occured', 15);
	},
};

export default class ErrorHandler {
	constructor(router) {
		this.router = router;
	}

	isToHandleError(code) {
		let doNothing = [
			'INVALID_REGISTRATION_STATUS',
			'EMAIL_TOKEN_EXPIRED',
			'EMAIL_TOKEN_ERROR',
			'USER_PROFILE_ERROR',
		];

		for (let i = 0; i < doNothing.length; i++) {
			const nothingErr = doNothing[i];
			if (nothingErr === code) {
				return false;
			}
		}

		return true;
	}

	async handleError(err) {
		try {
			if (err && err.err_code) {
				let code = err.err_code.toString();

				if (this.isToHandleError(code)) {
					let errAction = knownErrors[code];

					if (errAction) {
						await errAction(err);
					} else {
						if (err.err_msg) {
							$notify('error', err.err_code, err.err_msg);
						} else {
							await knownErrors['unknown'](err);
						}
					}
				}
			} else {
				if (err.message) {
					$notify('error', 'Error', err.message);
				} else if (err.err_msg) {
					$notify('error', 'Error', err.err_msg);
				} else {
					$notify('error', 'Error', 'An Error Occured.');
				}
			}
		} catch (error) {
			console.log(error);
		}
	}
}
